import { ProductResource, ProductVariantResource } from '@/api/serverApi'
import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

export type ProductsSlice = {
  products: ProductResource[]
  productVariants: ProductVariantResource[]
}

const initialState: ProductsSlice = {
  products: [],
  productVariants: [],
}

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<ProductResource[]>) => {
      state.products = action.payload
    },
    setProductVariants: (state, action: PayloadAction<ProductVariantResource[]>) => {
      state.productVariants = action.payload
    },
  },
})

export const { setProducts, setProductVariants } = productsSlice.actions

export default productsSlice.reducer
